export default __webpack_public_path__ + "static/media/contributors.aad0eae2.svg";